export const state = () => ({
  title: ''
})

export const mutations = {
  setTitle (state, string) {
    state.title = string
  },
}
